import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconElectrocardiogram: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconElectrocardiogram"><Path d="M1.75 11.7501H3.64604C5.02802 11.7501 6.2312 10.806 6.55993 9.46366L8.01889 3.50627C8.26834 2.48767 9.71783 2.49103 9.96257 3.51077L14.018 20.4083C14.2639 21.4328 15.7225 21.4296 15.9638 20.404L17.4558 14.0629C17.7747 12.7078 18.9839 11.7501 20.376 11.7501H22.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconElectrocardiogram;
